// extracted by mini-css-extract-plugin
export default {"contactFormBox":"memberForm_contactFormBox__F2nDE"};